import { API_URL } from './_config.js';
import { marked } from 'marked';

marked.setOptions({
    gfm: true,
    breaks: true,
    smartLists: true,
    smartypants: true
});

const chatMessages = document.getElementById('chat-messages');
const chatInput = document.getElementById('chat-input');
const chatSubmit = document.getElementById('chat-submit');

let isFirstMessage = true;
let triggerTracking = false;

function trackingEvent() {
    if (triggerTracking) return;
    
    try {
        if (!window.analytics) {
            console.warn('Analytics não está disponível');
            return;
        }

        const customUrlParams = new URLSearchParams(window.location.search);
        const trackingData = {
            utm_source: customUrlParams.get('utm_source') || '',
            utm_medium: customUrlParams.get('utm_medium') || '',
            utm_campaign: customUrlParams.get('utm_campaign') || '',
            utm_content: customUrlParams.get('utm_content') || '',
            url: window.location.href
        };

        window.analytics.track('ai_irs_interaction', trackingData);
        triggerTracking = true;
        console.log('Tracking event disparado e bloqueado para próximas tentativas');
    } catch (error) {
        console.error('Erro ao enviar evento de tracking:', error);
    }
}

export const removeHighlightRecentMsg = () => {
    document.querySelectorAll('.user-new-question').forEach(element => {
        element.classList.remove('user-new-question');
    });
}

export function toggleLoadingAnimation(show) {
    const loading = document.getElementById('loading');
    const chatMessengerInput = document.getElementById('chat-input-container');
    if(!show) {
        console.log('hide loader');
        chatMessengerInput.classList.remove('disabled');
        loading.classList.add('hidden');
    } else {
        console.log('show loader');
        chatMessengerInput.classList.add('disabled'); 
        loading.classList.remove('hidden');
    }
}

export const addMessageToChat = (message, sender = 'bot', el) => {
    const messageElement = document.createElement('div');
    messageElement.classList.add('flex', 'flex-col', 'w-full');

    if (sender === 'bot') {
        // Formatação do texto da mensagem

        // const formattedMessage = marked(message);

        const formattedMessage = message.replace(/### (\d+)\. \*\*(.*?)\*\*/g, '<h3>$1. $2</h3>') 
                                        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')      
                                        .replace(/- (.*?)$/gm, '<li>$1</li>')                  
                                        .replace(/<\/li>\n<li>/g, '</li><li>')                  
                                        .replace(/<li>(.*?)<\/li>/g, '<ul><li>$1</li></ul>')   
                                        .replace(/<\/ul>\n<ul>/g, '')                         
                                        .replace(/<\/ul>\n<h3>/g, '</ul><br><h3>');           

        messageElement.innerHTML = `
        <div class="flex justify-start my-0 text-16 w-full flex-row gap-x-4 pb-4">
            <svg class="flex flex-none" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="url(#a_bg_svg)"/><path d="M19.815 30.286a8.571 8.571 0 0 1 0-17.143v17.142Z" fill="#FDBD9A"/><path d="M21.243 10a7.142 7.142 0 1 1 0 14.286V10Z" fill="#F2F2F2"/><defs><linearGradient id="a_bg_svg" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse"><stop stop-color="#FE7165"/><stop offset="1" stop-color="#FF8D78"/></linearGradient></defs></svg>
            <div class="bg-transparent text-black rounded-24 px-2 text-16 text-darkblue leading-160 flex flex-col gap-y-2 w-full">
                ${formattedMessage}
            </div>
        </div>`;  

        removeHighlightRecentMsg();
    } else {
        messageElement.innerHTML = `
        <div class="flex justify-end my-0 text-16 w-full">
            <div class="bg-white rounded-user user-new-question px-5 py-4 max-w-550 ml-auto text-16 text-darkblue leading-140">
                ${message}
            </div>
        </div>`;  
    }

    chatMessages.appendChild(messageElement);
    chatMessages.scrollTop = chatMessages.scrollHeight;
};

const sendMessage = async (message, sessionId, isFirst = false) => {
    toggleLoadingAnimation(true);
    addMessageToChat(message, 'user');
    chatInput.value = '';

    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                action: 'sendMessage', 
                sessionId: sessionId,
                chatInput: message,
                isFirstMessage: isFirst
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        toggleLoadingAnimation(false);

        if (data.output) {
            const replyMessage = marked(data.output);
            addMessageToChat(replyMessage);
        }

        if (isFirst) {
            isFirstMessage = false;
            setTimeout(() => {
                displayFollowUpQuestions(['Tenho dúvidas sobre a opção entre tributação conjunta e separada com o meu cônjuge. Como posso determinar qual é a opção mais vantajosa para nós?', 'Investi num Plano Poupança Reforma (PPR) no ano passado. Qual é o limite de dedução a que tenho direito e como verifico se está incluído na minha declaração?', 'Na modelo 3, quais são os limites para despesas de saúde?'], sessionId, false);
            }, 2000);

            trackingEvent();
        }
    } catch (error) {
        console.error('Error sending message:', error);
        toggleLoadingAnimation(false);
        addMessageToChat('Desculpa, ocorreu um erro ao processar sua mensagem. Por favor, tente novamente.', 'bot');
    }
};

const displayFollowUpQuestions = (questions, sessionId, first = false) => {
    if (!questions || questions.length === 0) return;

    const followUpContainer = document.createElement('div');
    followUpContainer.className = 'flex flex-wrap justify-end gap-x-2 gap-y-2 mb-2';

    questions.forEach(question => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'transition duration-300 ease-in-out shadow-custom bg-lighterpeppermint border border-darkblue rounded-12 text-darkblue font-semibold px-3 py:3 lg:px-5 lg:py-4 hover:shadow-full-peppermint hover:border-lighterpeppermint text-14 max-w-560 text-left';
        button.textContent = question;
        
        button.onclick = () => {
            if (first) {
                trackingEvent();
            }
            sendMessage(question, sessionId);
            toggleLoadingAnimation(true);
        };
        
        followUpContainer.appendChild(button);
    });

    chatMessages.appendChild(followUpContainer);
    chatMessages.scrollTop = chatMessages.scrollHeight;
};

export const welcomeMessage = (sessionId) => {
    toggleLoadingAnimation(true);

    setTimeout(() => {
        addMessageToChat('Olá! Sou o assistente da Coverflex especializado em ajudar com o preenchimento da Modelo 3 de IRS.<br>Deixo te aqui uma primeira sugestão de pergunta para me fazeres:', 'bot');

        setTimeout(() => {
            displayFollowUpQuestions(['Paguei despesas de saúde, educação e habitação durante o ano. Como posso verificar se todas estas despesas estão corretamente classificadas no e-fatura e refletidas na minha declaração?'], sessionId, true);
            toggleLoadingAnimation(false);
        }, 1000);
    }, 1000);
};

export const initThread = (sessionId) => {
    chatSubmit.addEventListener('click', () => {
        const message = chatInput.value.trim();
        if (message) {
            sendMessage(message, sessionId, isFirstMessage);
        }
    });

    chatInput.addEventListener('keyup', (event) => {
        if (event.key === 'Enter') {
            const message = chatInput.value.trim();
            if (message) {
                sendMessage(message, sessionId, isFirstMessage);
            }
        }
    });
};
